export enum StoreErrorMessage {
  VersionUndefined = 'Version is not set',
  OrganizationMissing = 'Organization is required',
  NotBeloningToOrganization = 'Project must belong to an organization for it to be used as template',
  VersionError = 'Version could not be added',
}
